import { PLAN_KINDS } from '@/modules/account/constants'
import type { Plan } from '@/modules/auth/stores/types'
import { PLANS } from '@/modules/auth/stores/types'
import { DemoCallout } from './DemoCallout'
import { SingleProjectCard } from './SingleProjectCard'
import { SubscriptionPlanCard } from './SubscriptionPlanCard'

interface SubscriptionTier {
  description: string
  features: string[]
}

const CORE_TIER: SubscriptionTier = {
  description:
    'For firms pulling statements across a steady caseload. The lowest cost per matter for high-volume extraction.',
  features: ['Extraction'],
}

const PLUS_TIER: SubscriptionTier = {
  description:
    'For firms that question statements on most matters and want charts, tables, and exhibits back.',
  features: ['Extraction', 'AI Chat', 'Forensic reports'],
}

const SUBSCRIPTION_TIERS: Record<string, SubscriptionTier> = {
  [PLANS.ANNUAL_CORE]: CORE_TIER,
  [PLANS.MONTHLY_CORE]: CORE_TIER,
  [PLANS.ANNUAL_PLUS]: PLUS_TIER,
  [PLANS.MONTHLY_PLUS]: PLUS_TIER,
}

interface PlanInformationProps {
  plan: Plan
}

export const PlanInformation = ({ plan }: PlanInformationProps) => {
  const tier = SUBSCRIPTION_TIERS[plan.displayName]

  return (
    <div className="space-y-4">
      {plan.displayName === PLANS.SINGLE_PROJECT ? (
        <SingleProjectCard plan={plan} />
      ) : (
        tier && (
          <SubscriptionPlanCard
            plan={plan}
            description={tier.description}
            features={tier.features}
          />
        )
      )}
      <DemoCallout
        variant={
          plan.kind === PLAN_KINDS.single_project
            ? PLAN_KINDS.single_project
            : PLAN_KINDS.subscription
        }
      />
    </div>
  )
}
